import { render } from "./PopupBanner.vue?vue&type=template&id=7d7c10b0&scoped=true"
import script from "./PopupBanner.vue?vue&type=script&lang=js"
export * from "./PopupBanner.vue?vue&type=script&lang=js"

import "./PopupBanner.vue?vue&type=style&index=0&id=7d7c10b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7c10b0"]])

export default __exports__